import React, { useEffect } from 'react';
import analytics from '../../analytics';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { PrimaryButton, DefaultButton } from '../buttons';
import styles from './modals.module.scss';
import { DeleteListItemModalProps } from './types';

const { defaultButton, primaryButton, modalFooterWithTwoButtons, customModal } = styles;

export const DeleteListItemModal = (props: DeleteListItemModalProps) => {
    const { isOpen, onModalYes, onModalNo, bodyText, isBodyTextHtml = false } = props;

    useEffect(() => {
        if (isOpen) {
            analytics.sendModalview('delete-item');
        }
    }, [isOpen]);

    return (
        <Modal centered={true} isOpen={isOpen} data-testid='nested-delete-modal' contentClassName={customModal}>
            <ModalHeader>Confirm</ModalHeader>
            <ModalBody>
                {isBodyTextHtml && <div dangerouslySetInnerHTML={{ __html: bodyText || 'Are you sure?' }} />}
                {!isBodyTextHtml && <div>{bodyText || 'Are you sure?'}</div>}
            </ModalBody>
            <ModalFooter className={modalFooterWithTwoButtons}>
                <DefaultButton
                    className={defaultButton}
                    onClick={onModalNo}
                    data-testid='delete-modal-no'
                >
                    No
                </DefaultButton>
                <PrimaryButton className={primaryButton} data-testid='delete-modal-yes' onClick={onModalYes}>Yes, delete</PrimaryButton>
            </ModalFooter>
        </Modal>
    );
};
